'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _collections = require('redux/modules/collections');

var collectionActions = _interopRequireWildcard(_collections);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

var _ = require('./');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionPersonal = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    collection: state.collections.collection,
    province: state.address.province,
    lists: state.collections.lists,
    total: state.collections.total,
    pageSize: state.collections.pageSize,
    loading: state.collections.loading,
    loaded: state.collections.loaded,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, collectionActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SectionPersonal, _Component);

  function SectionPersonal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SectionPersonal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SectionPersonal.__proto__ || (0, _getPrototypeOf2.default)(SectionPersonal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      pageSize: 12,
      lazy: false,
      firstLoad: false,
      sort: ''
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SectionPersonal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loaded && this.props.loading !== true || !this.props.lists || !this.state.firstLoad) {
        this.getResult.call(this);
      }
      document.addEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loading) {
        this.setState({ firstLoad: true });
      }
      if (nextProps.pageSize !== this.props.pageSize) {
        this.setState({ pageSize: nextProps.pageSize });
      }
      if (!(0, _lodash.isEqual)(this.props.lists, nextProps.lists)) {
        this.props.getOffset();
      }
      if (!nextProps.loading) {
        this.setState({ lazy: false });
      }
      if (nextProps.province !== this.props.province) {
        this.getResult.call(this);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'seeMoreCollection',
    value: function seeMoreCollection(seeMore) {
      var tracking = this.props.tracking;

      this.props.manualTrack((0, _extends3.default)({}, tracking, { button: seeMore ? 'See More' : 'Section Title', label: seeMore ? 'Xem thêm' : this.props.name }));
      if (seeMore === true) {
        _reactGa2.default.event({
          category: 'Home Section',
          action: 'Clicked See More',
          label: 'Collection'
        });
      } else {
        _reactGa2.default.event({
          category: 'Home Section',
          action: 'Clicked Title',
          label: 'Collection'
        });
      }
    }
  }, {
    key: 'toCollectionDetail',
    value: function toCollectionDetail(collection) {
      _reactGa2.default.event({
        category: 'Collection',
        action: 'Clicked Collection Card',
        label: '' + collection.name
      });
    }
  }, {
    key: 'getResult',
    value: function getResult() {
      var filter = {
        province: this.props.province,
        pageSize: this.state.pageSize,
        sort: this.state.sort
      };
      this.props.load(filter);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./SectionPersonal.scss');
      var _props = this.props,
          slogan = _props.slogan,
          name = _props.name,
          user = _props.user;

      var title = "Đề xuất dành riêng cho bạn nè!";
      if (user) {
        title = '\u0110\u1EC1 xu\u1EA5t d\xE0nh ri\xEAng cho ' + user.profile.name + ' n\xE8!';
      }
      return _react2.default.createElement(
        'div',
        { className: styles.personal },
        _react2.default.createElement(
          'div',
          { className: styles.headerBox },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(
              'div',
              { className: styles.left },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/bo-suu-tap', onClick: function onClick() {
                    return _this2.seeMoreCollection();
                  } },
                _react2.default.createElement(
                  'h1',
                  { className: styles.title },
                  title
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.right },
              _react2.default.createElement('img', { className: styles.imgPersonal, src: _Images2.default.catPersonal })
            )
          ),
          !!slogan && _react2.default.createElement(
            'div',
            { className: styles.slogan },
            slogan
          )
        ),
        _react2.default.createElement(_.Collection, {
          tracking: { screen: 'Home', section: 'Bộ sưu tập' },
          manualTrack: this.props.manualTrack
          // name="Bộ sưu tập"
          // slogan="Thoả sức check–in, đa dạng lựa chọn"
          // getOffset={this.props.getOffset}
        }),
        _react2.default.createElement(_.NearMeMobile, {
          tracking: { screen: 'Home', section: 'Địa điểm gần bạn' },
          manualTrack: this.props.manualTrack
          // getOffset={this.props.getOffset}
          , name: 'TOPSPA/SALON G\u1EA6N B\u1EA0N'
          // slogan="Tiết kiệm thời gian làm đẹp ngay gần vị trí của bạn"
          // banners={banners}
        })
      );
    }
  }]);
  return SectionPersonal;
}(_react.Component), _class2.propTypes = {
  params: _react.PropTypes.object,
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  load: _react.PropTypes.func.isRequired,
  collection: _react.PropTypes.object,
  total: _react.PropTypes.number,
  pageSize: _react.PropTypes.number,
  lists: _react.PropTypes.array,
  province: _react.PropTypes.string,
  slogan: _react.PropTypes.string,
  name: _react.PropTypes.string,
  tracking: _react.PropTypes.object,
  user: _react.PropTypes.object,

  getOffset: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = SectionPersonal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/SectionPersonal.js
// module id = 1608
// module chunks = 0